<!-- 购买弹窗 -->
<template>
<el-dialog title="购买题库" :visible.sync="specialTopicBuyDialogVisible" width="800px" :before-close="handleClose" class="buy-dialog" :close-on-click-modal="false" :close-on-press-escape="false">
    <div v-loading="contentLoading">
        <el-scrollbar class="buy-dialog-scroll">
            <div class="module-item">
                <div class="module-title">
                    题库名称
                </div>
                <div class="bank-item-box">
                    <div class="bank-item" :class="{active: item.examcode === params.examcode}" @click="handleChangeExam(item, index)" v-for="(item, index) in subjectlist" :key="item.examcode">{{ item.label }}</div>
                </div>
            </div>
            <div class="module-item">
                <div class="module-title">
                    开通科目
                </div>
                <div class="subject-item-box">
                    <div class="subject-item" :class="{active: item.subjectcode === params.subjectcodes}" @click="handleChangeSubject(item)" v-for="(item) in subjectlist[currentTopicIndex].subjectList" :key="item.subjectcode">
                        {{ item.label }}
                    </div>
                </div>
            </div>
            <div class="module-item">
                <div class="module-title">
                    开通时长
                </div>
                <div class="expiredate">
                    有效期：12个月
                </div>
            </div>
        </el-scrollbar>
        <div class="dialog-footer">
            <div class="ordermoney-tips">
                <div class="ordermoney">
                    <div class="label">支付金额：</div>
                    <div class="value">￥{{ params.ordermoney }}</div>
                </div>
                <div class="tips">购买提示：题库属虚拟产品，不支持退款服务，敬请谅解!</div>
            </div>
            <el-button class="buy-btn" @click="handleBuy" :loading="buyLoading">立即购买</el-button>
        </div>
    </div>
</el-dialog>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {uploadTopicQuestionBankOrder, getTopicQBBaseInfoAll} from '@/api/specialTopic.js'
import specialTopic from '@/common/js/specialTopic.json'
export default {
    data() {
        return {
            dialogVisible: false,
            subjectlist: [],
            currentTopicIndex: 0,
            params: {
                bindsubjectcount: 1, // 绑定购买科目数，1-4
                clienttype: 1, // 客户端类型：1PC 2移动 3微信 4小程序 5App 
                discountmoney: '', // 折扣金额，单位分
                examcode: '', // 专题code
                ordermoney: '', // 订单金额，单位分 
                paymoney: '', // 实际支付金额，单位分
                resulturl: '', // 支付完成返回路径
                subjectcodes: '', // 科目Code，多个逗号分隔
                subjectnames: '', // 科目名称，多个逗号分隔
            },
            expiredate: '',
            buyLoading: false,
            contentLoading: false,
            examinfo: {}
        }
    },
    props: {
        subject: {
            default: () => {
                return {}
            },
            type: Object
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        this.subjectlist = JSON.parse(JSON.stringify(specialTopic.buySubjectList))
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        handleOpen(examcode) {
            this.setSpecialTopicBuyDialogVisible(true)
            // this.params.examcode = examcode ? examcode : 'jjcy'
            // this.params.subjectcodes = this.subject.code ? this.subject.code : this.subjectlist[examcode][0].subjectcode
            // this.params.subjectnames = this.subject.name ? this.subject.name : this.subjectlist[examcode][0].subjectname
            // if (!this.subject.isjoin) {
            //     let currentDate = new Date().getFullYear() + '/' + (new Date().getMonth() + 1) + '/' + new Date().getDate()
            //     let targetDate = new Date(new Date(currentDate).getTime() + (this.examinfo.expiredays * 24 * 60 * 60 * 1000))
            //     this.expiredate = targetDate.getFullYear() + '年' + (targetDate.getMonth() + 1) + '月' + targetDate.getDate() + '日'
            // } else {
            //     let targetDate = new Date(new Date(this.subject.expiredate).getTime() + (this.examinfo.expiredays * 24 * 60 * 60 * 1000))
            //     this.expiredate = targetDate.getFullYear() + '年' + (targetDate.getMonth() + 1) + '月' + targetDate.getDate() + '日'
            // }

            this.handleInit(examcode ? examcode : 'jjcy', this.subject.code)
        },
        handleInit(examcode, subjectcode) {
            this.params.examcode = examcode
            if (subjectcode) {
                this.params.subjectcodes = subjectcode
                this.subjectlist.some((item, index) => {
                    if (item.examcode === examcode) {
                        this.currentTopicIndex = index
                        item.subjectList.some(option => {
                            if (option.subjectcode === subjectcode) {
                                this.params.subjectnames = option.subjectname
                                return true
                            }
                        })
                        return true
                    }
                })
            } else {
                this.subjectlist.some((item, index) => {
                    if (item.examcode === examcode) {
                        this.currentTopicIndex = index
                        this.params.subjectcodes = item.subjectList[0].subjectcode
                        this.params.subjectnames = item.subjectList[0].subjectname
                        return true
                    }
                })
            }
            this.handleGetTopicQBBaseInfoAll()
        },
        handleGetTopicQBBaseInfoAll() {
            this.contentLoading = true
            getTopicQBBaseInfoAll({
                data: {examcode: this.params.examcode},
                success: data => {
                    data.data.forEach(item => {
                        this.subjectlist.some(option => {
                            if (option.examcode === item.examcode) {
                                option.subjectList.forEach(obj => {
                                    obj.uprice = item[obj.upricename]
                                    if (this.params.subjectcodes === obj.subjectcode) {
                                        this.params.ordermoney = obj.uprice
                                        this.params.bindsubjectcount = obj.bindsubjectcount
                                    }
                                })
                            }
                        })
                    })
                    this.contentLoading = false
                },
                error: error => {
                    this.contentLoading = false
                    this.$message.error(error.msg)
                }
            })
        },
        handleClose() {
            this.setSpecialTopicBuyDialogVisible(false)
            this.params.examcode = ''
            this.params.subjectcodes = ''
            this.params.subjectnames = ''
            this.params.bindsubjectcount = 1
        },
        handleChangeExam(item, index) {
            if (this.params.examcode !== item.examcode) {
                this.params.examcode = item.examcode
                this.currentTopicIndex = index
                this.handleChangeSubject(item.subjectList[0])
            }
        },
        handleChangeSubject(item) {
            if (this.params.subjectcodes !== item.subjectcode) {
                this.params.subjectcodes = item.subjectcode
                this.params.subjectnames = item.subjectname
                this.params.ordermoney = item.uprice
                this.params.bindsubjectcount = item.bindsubjectcount
            }
        },
        handleBuy() {
            this.buyLoading = true
            let params = JSON.parse(JSON.stringify(this.params))
            params.ordermoney = params.ordermoney * 100
            params.paymoney = params.ordermoney
            params.discountmoney = 0
            params.resulturl = location.origin + '/specialTopic' + `/${this.params.examcode}` + '/buyresult'
            uploadTopicQuestionBankOrder({
                data: params,
                success: data => {
                    this.buyLoading = false
                    window.location.replace(data.data.url)
                },
                error: error => {
                    this.buyLoading = false
                    this.$message.error(error.msg)
                }
            })
        },
        ...mapActions([
            'setSpecialTopicBuyDialogVisible'
        ])
    },
    computed: {
        ...mapGetters([
            'specialTopicBuyDialogVisible'
        ])
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
.buy-dialog {
    display: flex;
    align-items: center;
    .el-dialog {
        border-radius: 10px;
        margin: 0 auto !important;
        .el-dialog__header {
            padding: 15px 20px;
            .el-dialog__title {
                font-size: 16px;
                color: #333333;
                line-height: 22px;
                height: 22px;
                display: block;
                font-weight: bold;
            }
        }
        .el-dialog__body {
            padding: 0;
            height: 457px;
            .buy-dialog-scroll {
                height: 390px;
                .el-scrollbar__wrap {
                    height: calc(100% + 17px);
                    .el-scrollbar__view {
                        padding: 5px 20px 20px;
                        box-sizing: border-box;
                        .module-item {
                            &:not(:last-of-type) {
                                margin-bottom: 20px;
                            }
                            .module-title {
                                display: flex;
                                align-items: center;
                                font-size: 14px;
                                color: #333333;
                                font-weight: bold;
                                margin-bottom: 15px;
                                &::before {
                                    width: 3px;
                                    height: 13px;
                                    content: '';
                                    background: #3A7EE3;
                                    margin-right: 5px;
                                    border-radius: 10px;
                                }
                            }
                            .bank-item-box {
                                display: flex;
                                align-items: center;
                                .bank-item {
                                    width: 125px;
                                    height: 36px;
                                    border-radius: 4px;
                                    text-align: center;
                                    line-height: 36px;
                                    background: #F0F2F5;
                                    font-size: 14px;
                                    color: #333333;
                                    cursor: pointer;
                                    &:not(:last-of-type) {
                                        margin-right: 15px;
                                    }
                                    &.active {
                                        background: rgba(58,126,227,0.1);
                                        color: #3A7EE3;
                                        cursor: default;
                                    }
                                }
                            }
                            .subject-item-box {
                                display: flex;
                                align-items: center;
                                flex-wrap: wrap;
                                .subject-item {
                                    padding: 0 20px;
                                    background: #F0F2F5;
                                    font-size: 14px;
                                    color: #333333;
                                    border-radius: 4px;
                                    cursor: pointer;
                                    margin-bottom: 15px;
                                    line-height: 36px;
                                    box-sizing: border-box;
                                    border: 1px solid #F0F2F5;
                                    &:not(:last-of-type) {
                                        margin-right: 15px;
                                    }
                                    &.active {
                                        background: rgba(58,126,227,0.1);
                                        color: #3A7EE3;
                                        cursor: default;
                                        border: 1px solid #3A7EE3;
                                    }
                                }
                            }
                            .expiredate {
                                width: 232px;
                                height: 36px;
                                background: #FCF5E7;
                                border-radius: 4px;
                                text-align: center;
                                line-height: 36px;
                                position: relative;
                                font-size: 14px;
                                color: #785B18;
                                &::after {
                                    content: '';
                                    width: 20px;
                                    height: 20px;
                                    position: absolute;
                                    right: 0;
                                    bottom: 0;
                                    background: url('../../../../../common/images/specialTopic/select_icon.png');
                                    background-size: 100% 100%;
                                }
                            }
                        }
                    }
                }
            }
        }
        .dialog-footer {
            padding: 10px 20px;
            height: 67px;
            box-sizing: border-box;
            border-top: 1px solid #EEEEEE;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .ordermoney-tips {
                display: flex;
                align-items: center;
                .ordermoney {
                    display: flex;
                    align-items: center;
                    margin-right: 40px;
                    .label {
                        font-size: 14px;
                        color: #333333;
                        line-height: 20px;
                    }
                    .value {
                        font-size: 24px;
                        color: #FA2B19;
                        line-height: 34px;
                    }
                }
                .tips {
                    font-size: 12px;
                    color: #FF3838;
                }
            }
            .buy-btn {
                width: 160px;
                height: 48px;
                padding: 0;
                border: none;
                border-radius: 100px;
                background: linear-gradient( 90deg, #413E31 0%, #4E4A41 100%);
                text-align: center;
                line-height: 48px;
                font-size: 16px;
                color: #F6D692;
                font-weight: bold;
                cursor: pointer;
            }
        }
    }
}
</style>